export enum ThemeType {
  DARK = "dark",
  LIGHT = "light",
}

export const defaultThemeType = ThemeType.DARK;
